import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ROUTES } from '../.././sidebar/sidebar.component';
import { Location } from '@angular/common';
import {AuthenticationService} from '../../services/authentication.service'
import {BaseComponent} from '../../shared/core/base.component'
import { ProfileService } from '../../services/profile.service';
import { DashboardService } from '../../services/dashboard.service';

const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;
@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent extends BaseComponent implements OnInit  {
    private listTitles: any[];
    location: Location;
    mobile_menu_visible: any = 0;
    private toggleButton: any;
    private sidebarVisible: boolean;
    serverRevision:string[] =[];
    clientRevision:string[] =[];
    year:number;
    credentialPairs: any[] = [];
    @ViewChild('app-navbar-cmp', {static: false}) button: any;

    constructor(location: Location, private element: ElementRef, authenticationService:AuthenticationService,private dashboardService:DashboardService,private profileService:ProfileService ) {
        super(authenticationService);
        this.location = location;
        this.sidebarVisible = false;
        this.serverRevision.push("");
        this.serverRevision.push("");
        this.clientRevision.push("");
        this.clientRevision.push("");
        var d = new Date();
        this.year = d.getFullYear();
    }
  

    ngOnInit() {
        this.listTitles = ROUTES.filter(listTitle => listTitle);

        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
        /*this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
          this.sidebarClose();

          const $layer = document.getElementsByClassName('close-layer')[0];
          if ($layer) {
            $layer.remove();
          }
        });*/
        this.clientRevision = this.authenticationService.getClientBuild();
      this.authenticationService.getServerBuild()
                .subscribe(result => {
                  this.serverRevision=result;
                });
      if (this.isRootUser()) {
        this.dashboardService.dashboard.subscribe(result => {
          this.processDashboardResponse(result);
          this.credentialPairs = [
            { name: 'Client Id', value: this.getClientId() || '' },
            { name: 'Client Secret', value: '' }
          ];
        });
      }
    }
    onResize(event) {
      if ($(window).width() > 991) {
        return false;
      }
      return true;
    }
    sidebarOpen() {
      var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function(){
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');
        setTimeout(function() {
            $toggle.classList.add('toggled');
        }, 430);

        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');


        if (body.querySelectorAll('.main-panel')) {
            document.getElementsByClassName('main-panel')[0].appendChild($layer);
        }else if (body.classList.contains('off-canvas-sidebar')) {
            document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
        }

        setTimeout(function() {
            $layer.classList.add('visible');
        }, 100);

        $layer.onclick = function() { //asign a function
          body.classList.remove('nav-open');
          this.mobile_menu_visible = 0;
          this.sidebarVisible = false;

          $layer.classList.remove('visible');
          setTimeout(function() {
              $layer.remove();
              $toggle.classList.remove('toggled');
          }, 400);
        }.bind(this);

        body.classList.add('nav-open');
        this.mobile_menu_visible = 1;
        this.sidebarVisible = true;
    };
    sidebarClose() {
      var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');

        this.sidebarVisible = false;
        body.classList.remove('nav-open');
        // $('html').removeClass('nav-open');
        body.classList.remove('nav-open');
        if ($layer) {
            $layer.remove();
        }

        setTimeout(function() {
            $toggle.classList.remove('toggled');
        }, 400);

        this.mobile_menu_visible = 0;
    };
    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    getTitle() {
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
      if(this.getPath() == "#/dashboard")
            return "Vector Viewer Dashboard";
        for (let i = 0; i < this.listTitles.length; i++) {
            if (this.listTitles[i].type === "link" && this.listTitles[i].path === titlee) {
                return this.listTitles[i].title;
            } else if (this.listTitles[i].type === "sub") {
                for (let j = 0; j < this.listTitles[i].children.length; j++) {
                    let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                    if (subtitle === titlee) {
                        return this.listTitles[i].children[j].title;
                    }
                }
            }
        }
        if(this.getPath() == "#/profile")
            return "Users";
        else if(this.getPath() == "#/dashboard")
            return "Vector Viewer Dashboard";
        else if(this.getPath() == "#/settings")
            return "Global Config";
        else if(this.getPath() == "#/changepassword")
            return "Change Password";
        return 'Dashboard';
    }
    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }
    getUserEmail(): string {
        const currentUser = JSON.parse(sessionStorage.getItem('vvuser'));
        return currentUser ? (currentUser.email || currentUser.username || '') : '';
    }

    getUserInitials(): string {
        const email = this.getUserEmail();
        if (!email) { return 'VV'; }
        const localPart = email.split('@')[0];
        const parts = localPart.split(/[._-]/);
        if (parts.length >= 2 && parts[0].length && parts[parts.length - 1].length) {
            return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        }
        return localPart.substring(0, 2).toUpperCase();
    }

    logout()
    {
        this.authenticationService.logout()
                .subscribe(result => {
                    this.profileService.clearCache();
                    this.dashboardService.clearCache();
                    this.redirectToLogin();
                    });
    }
    changepassword()
    {
        this.authenticationService.changePassword()
                .subscribe(result => {
                    this.showMessage("success","Email sent with instructions to reset your password");
                    });
    }

    generateClientSecret()
    {
        this.showConfirmationMsg1(
            'Are you sure you want to generate a new API secret key? The previous key will become invalid immediately.',
            this.confirmSecretGeneration,
            null,
            this.credentialPairs
        );
    }

    confirmSecretGeneration(result, entity: any, authService: any, copyFn: any, list: any[])
    {
        if (result.value) {
            authService.generateClientSecret(false).subscribe((res: any) => {
                list[1].value = res.secret;
            });
        }
    }

    copyToClipboard(val: string): void {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(val).then(() => this.showMessage('success', 'Copied to clipboard'));
        }
    }

    getName(email: string): string {
        if (!email) { return ''; }
        const local = email.split('@')[0];
        const parts = local.split(/[._-]/);
        if (parts.length >= 2) {
            return parts.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ');
        }
        return local.charAt(0).toUpperCase() + local.slice(1);
    }
}
